import React from "react";
import { FormattedMessage } from "react-intl";

export const LevelTitle = ({ index }: { index: number }) => (
  <FormattedMessage id="level.title" defaultMessage="Level {levelIndex}" values={{ levelIndex: index + 1 }} />
);
